import React, { useState, useEffect, useContext } from 'react';
import CardContent from '@material-ui/core/CardContent';
import API from '../../services/api';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import TrackAction from '../TrackItem/trackAction';
import TrackContext from '../../contexts/track-context';
import { ReactComponent as Play } from '../../assets/play.svg';
import { ReactComponent as Pause } from '../../assets/pause.svg';
import Amplitude from 'amplitudejs';
import { ReactComponent as Add } from '../../assets/GreenButtonRoundPlusSmall.svg';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ReactComponent as DisableAdd } from '../../assets/disableAdd.svg';
import { ReactComponent as Project } from '../../assets/project.svg';
import { ReactComponent as Edit } from '../../assets/edit.svg';
import { ReactComponent as Delete } from '../../assets/delete.svg';
import { ReactComponent as Edit1 } from '../../assets/edit1.svg';
import { ReactComponent as Delete1 } from '../../assets/delete1.svg';
//import FavoriteIcon from '@material-ui/icons/Favorite';
import MobileAction from './mobileAction';
//import { ReactComponent as Success } from '../../assets/success.svg';
//import {ReactComponent as Points} from '../../assets/vPoints.svg';
import CookieManager from '../../services/CookieManager';
import dayjs from 'dayjs';
import Pagination from '@material-ui/lab/Pagination';
import Constants from '../../services/constants';
import Helper from '../../services/helper'
import ConfirmationPopup from '../../pure-components/ConfirmationPopup';
import MobilePopup from '../../pure-components/MobilePopup';
import { BouncingLoader } from "../../pure-components/Loader";
import AddTrackToProjectPopup from "./addTrackToProjectPopup";
import SaveIcon from "@material-ui/icons/SaveOutlined";
// import DownloadIcon from "@material-ui/icons/GetAppSharp";

import DuplicateIcon from "@material-ui/icons/FileCopyOutlined";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ErrorToast, SuccessToast, WarningToast } from '../../pure-components/CustomToast';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { CircularProgress } from '@material-ui/core';
import SvgInline from "../../pure-components/SvgInLine";
import MewoService from '../../services/mewoService';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import defaultImage from "../../assets/default_music.png";

import PostAddIcon from '@mui/icons-material/PostAdd';
import ArticleIcon from '@mui/icons-material/Article';
// import EditSquareIcon from '@mui/icons-material/EditSquare';
import { DownloadIcon } from '../NewUI/icons';
// import { ReactComponent as EditIcon } from '../../assets/icons/edit-icon.svg';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import UpdateIcon from '@mui/icons-material/EditNote';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import DeleteProjectPopup from './deleteProjectPopup';

export default function Projects() {
  let trackContext = useContext(TrackContext);
  const [currentTrack, setCurrentTrack] = useState('')
  const [project, setProject] = useState({});
  const [projects, setProjects] = useState([]);
  const [searchProjects, setSearchProjects] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState('');
  const [trackToBeRemoveToProject, setTrackToBeRemoveToProject] = useState('');

  const [loaderAddTrackToProject, setLoaderAddTrackToProject] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [favs, setFavs] = useState([]);
  const [addProject, setAddProject] = useState({ title: false });
  const [totalProject, setTotalProject] = useState(0);
  const [totalFavs, setTotalFavs] = useState(0);
  const [historyCount, setHistoryCount] = useState(0);
  const [favUpdated, setFavUpdated] = useState("")
  const [historyUpdated, setHistoryUpdated] = useState("");
  const [currPage, setCurrPage] = useState(1);
  const [pageSize, setPageSize] = useState(parseInt(process.env.REACT_APP_PAGE_SIZE));
  const [totalProjects, setTotalProjects] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [expanded, setExpanded] = useState({ index: -1, isOpen: false })
  const [searchKey, setSearchKey] = useState('')
  const [showConfirmPopup, setShowConfirmPopup] = useState(false)
  const [selectedAdmin, setSelectedAdmin] = useState({});
  const [download, setDownload] = useState([]);
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [editProjectObj, setEditProjectObj] = useState({});
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);
  const [projectIndex, setProjectIndex] = useState(0);//holds index of project from which track is played

  const [showTrackModal, setShowTrackModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadModalPosition, setDownloadModalPosition] = useState(null);
  const [downloadingTrackId, setDownloadingTrackId] = useState(null);
  const [downloadProjectData, setDownloadProjectData] = useState(null);
  const [projectDownloading, setProjectDownloading] = useState(false);
  const [projectDownloadModal, setProjectDownloadModal] = useState(false);
  const [projectDownloadModalPosition, setProjectDownloadModalPosition] = useState(null);
  
  //currently downloading 1 project at a time
  const [downloadingProjects, setDownloadingProjects] = useState([]);

  const [savingProject, setSavingProject] = useState(null);

  const [showDeleteTrackConfirmPopup, setShowDeleteTrackConfirmPopup] = useState(false);
  const [deletedTrackIndex, setDeletedTrackIndex] = useState("");
  const [deletedTrackFromProject, setDeletedTrackFromProject] = useState("");
  const [deletedTrackMsg, setDeletedTrackMsg] = useState("");
  const [trackDataLoading, setTrackDataLoading] = useState(false);

  const [downloadingTracks, setDownloadingTracks] = useState([]);
  const [favingTracks, setFavingTracks] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = useState(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const pageId='project'
  // useEffect(() => {
  //   console.log("test 1")
  //   fetchProjects(currPage, pageSize, searchKey);
  // }, []);

  useEffect(() => {
    //console.log("Project Data : ", searchProjects);
  }, [searchProjects])
  //rerendering track ui on song prev or next
  useEffect(() => {
    let historyId = trackContext.currentTrackDetail.historyId;
    if (historyId !== undefined && historyId !== null) {
      setCurrentTrack(historyId);
    }
  }, [trackContext.currentTrackDetail, currentTrack])

  //adding trackId's to trackContext.trackData to work play previous and next track
  const setTrackData = (index) => {
    const trackIds = searchProjects[index]?.trackIds?.map((track, index) => {
      return {
        "id": track.mewoTrackId,
        "_id": track?.track_index
      }
    })
    trackContext.setTrackData(trackIds);
    return trackIds
  }

  useEffect(() => {
    if (localStorage.getItem('favs')?.length > 0) {
      const favorites = JSON.parse(localStorage.getItem('favs') || "{}");
      // const favArray = favorites.map( track => {
      //   return track.trackId.mewoTrackId;
      // });
      if(Object.keys(favorites)?.length > 0)
        setFavs(Object.keys(favorites));
    };
    if (localStorage.getItem('download') !== 'undefined') {
      const download = JSON.parse(localStorage.getItem('download'));
      download !== null && setDownload(download);
    };
  }, []);

  const handlePagination = (e, pagenumber) => {
    // console.log(e.target.innerText);
    //let temp = e.target.innerText;
    setCurrPage(pagenumber);
  }
  const handleClose = () => {
    setShowDownloadModal(false);
  }
  useEffect(() => {
    (async () => {
      await fetchProjects(currPage, pageSize, searchKey);
    })();
  }, [currPage])

  const fetchProjects = async (currPage, pageSize, searchText) => {
    await API.getProjects(currPage, pageSize, searchText).then(data => {
      if (data.success) {
        setProjects(data.data);
        setTotalProject(data.totalCount)
        setSearchProjects(data.data);
        //adding track_index to track for uniqueness as there can be duplicate tracks
        data.data.forEach(project => project.trackIds.map((track, index) => track['track_index'] = track._id + index))
        setTotalProjects(data.totalCount)
        setTotalPages(Math.ceil(data.totalCount / pageSize));
      } else {
        let errorMsg = data.mssg;
        if (data.code === "401") {
          errorMsg += ", please signin again, if error persist please contact admin!";
        }
        toast(({ closeToast }) => <ErrorToast message={errorMsg} />);
      }
      setIsLoading(false);

    });
  }

  useEffect(() => {
    API.getHistoryTracks(1, 1).then(res => {
      setHistoryCount(res.totalCount);
      if (res?.history?.length)
        setHistoryUpdated(dayjs(res.history[0].updatedAt).format('DD.MM.YYYY'))
    })
  }, []);

  useEffect(() => {

  },[downloadingProjects])

  const handleAddProject = (e) => {
    let { value } = e.target;
    let newProject = { ...project };
    newProject[e.target.name] = value;
    setProject(newProject);
  }
  const createProject = async (e) => {
    if (!(project?.title?.length > 0))
      return;
    e.stopPropagation();
    await API.createProject({ ...project }).then(async res => {
      if (res.success === false) {
        // console.log('Response create Project:', res);
        toast(({ closeToast }) => <ErrorToast message={`Error Creating Project : ${res?.mssg}`} />);
      } else {
        setProject({});
        setAddProject({});
        await fetchProjects(currPage, pageSize, searchKey);
      }
    }).catch((err) => {
      toast(({ closeToast }) => <ErrorToast message={`Error Creating Project : ${err.status}: ${err?.message}`} />);
    });
  }
  const handleAddTrackToFavorites = async (trackData) => {
    setShowTrackModal(false)
    if (!trackContext.validateUser(Constants.ACTION.FAVOURITE)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.FAVOURITE);
      return;
    }
    // console.log("track Data : ", trackData);
    setFavingTracks([...favingTracks, trackData.trackId])
    const dataObj = {
      actionType : Constants.ACTION.FAVOURITE,
      trackId : trackData.trackId,
      title : trackData.title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.album.id,
        albumName : trackData.album.title,
        artistName : trackData.artist,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    }
    await API.addTrackToFavorites(dataObj).then((res) => {
      if (res.success) {
        localStorage.setItem("favs", JSON.stringify(res.favorites));
        setFavs(Object.keys(res.favorites));
        toast(({ closeToast }) => <SuccessToast message={res.mssg} />);
        
        const tempData = favingTracks;
        tempData?.length > 0 && tempData.splice(tempData.indexOf(trackData.trackId), 1);
        setFavingTracks(tempData);
          
      } else {
        console.log("Adding in favorite list failed.", res);
        toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
      }
    }).catch(err => {
      console.log("Adding in favorite list failed.", err);
      toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
    });
  }


  const closeProjectModal = () => {
    setShowProjectModal(false);
    setLoaderAddTrackToProject(false);
  }

  const loadProjects = async () => {
    await fetchProjects(currPage, pageSize, searchKey);
  }

  const fetchTrack = (trackId, isAltVersion, index, track_index) => {
    if (track_index === currentTrack) {
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
    trackContext.setLoadingTrack(true);
    API.playTrack(trackId).then(res => {
      trackContext.setLoadingTrack(false);
      if (res?.data?.success) {
        setCurrentTrack(track_index);
        setProjectIndex(currentProjectIndex)
        trackContext.setalltrackData(trackContext.trackData)
        trackContext.setPlayPause(true);
        if (Amplitude.getSongs().length) {
          Amplitude.stop();
          Amplitude.removeSong(0);
        }
        res.data.data['historyId'] = track_index
        trackContext.setCurrentTrack(res.data.data.audiofile)
        trackContext.setCurrentTrackDetail(res.data.data)
        trackContext.setCurrentTrackImage(res.data.data.album?.image.xsmall.url)
      } else {
        trackContext.setLoadingTrack(false);
        Helper.handleError(res?.data);
      }
    });
    if (isAltVersion) {
      fetchAltVersion(trackId, true, index)
    }
  }

  const playTrack = async(trackData) => {
    // console.log("track data : ", trackData);
    if (trackData.mewoTrackId === trackContext.currentTrackDetail.id && trackContext.playingFrom === pageId) {
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
    if (Amplitude.getSongs().length) {
      Amplitude.stop();
      Amplitude.removeSong(0);
    }
    trackContext.setPlayingFrom(pageId)
  
    trackContext.setCurrentTrack(trackData.audioRef);
    trackContext.setCurrentTrackImage(trackData.artworkRef);
    trackContext.setCurrentTrackDetail({
      title : trackData.trackId.title,
      display_title : trackData.trackId.title,
      album : {
        id : trackData.albumId || trackData.trackId.album.id,
        image : {
          original  : {url : trackData.artworkRef}
        }
      },
      id : trackData.mewoTrackId,
      artist: trackData.trackId.artist,
      duration : trackData.trackId.duration,
    });

    const dataObj = {
      actionType : Constants.ACTION.PLAY,
      trackId : trackData.trackId.trackId,
      title : trackData.trackId.title,
      trackDesc : trackData.trackId.description || "",
      trackData : {
        albumId : trackData.trackId.album.id,
        albumName : trackData.trackId.title,
        artistName : trackData.trackId.artist,
        duration : trackData.trackId.duration,
        bpm : trackData.trackId.bpm
      }
    } 
    await API.addPlayHistory(dataObj).then((res) => {
      if (res.success) {
        localStorage.setItem("history", JSON.stringify(res.history)); 
      } else {
        console.log("Track Adding in play history failed.", res);
      }
    }).catch(err => {
      console.log("Track Adding in play history failed.", err);
    });
  };

  const fetchAltVersion = (trackId, expandval = false, index) => {
    API.getAlternateVersions(trackId).then(res => {
      // console.log('[ALT VERSIONS]', res);
      if (res?.success) {
        if (res.data.length) {
          // console.log("IF");
          let newprojects = searchProjects;
          let expandedIndex = expanded.index;
          let project = { ...newprojects[expandedIndex] };
          let track = { ...project.trackIds[index] };
          track.alternateVersions = res.data;
          track.expand = expandval;
          project.trackIds[index] = { ...track }
          newprojects[expandedIndex] = { ...project };
          setSearchProjects([...newprojects]);
        }
      } else {
        Helper.handleError(res);
      }
    });
  }

  const handleSearch = Helper.debounce((searchText) => {
    setCurrPage(1);
    setSearchKey(searchText)
    fetchProjects(1, pageSize, searchText);
  }, 500)

  const getTracksInfo = async (trackIds) => {
    let errMsg = "Info : No record found for Track(s) : ";
    let errorOccured = false;
    let trackData = {};
    const taskArr = trackIds.map(async (trackId, index) => {
      if (!trackId?.length)
        return;

      let reqObj = {
        url: `public/play/track/${trackId}`,
        method: 'get'
      };

      await MewoService.loadMewoData(reqObj).then(async function (resp) {
        if (resp) {
          // console.log("trackData : ", resp);
          trackData[trackId] = {
            album: resp.album,
            duration: resp.duration,
            mewoTrackId: resp.id,
            mewoTrackUrl: resp.audiofile,
            waveform: resp.waveform,
            title: resp.title

          };
        }
        return;
      }).catch(function (error) {
        console.log(`TrackDataLoadingError for Track : ${trackId}`, error);
        errorOccured = true;
        errMsg += `${trackId}, `
        return;
      });
    });

    return await Promise.allSettled(taskArr).then(async results => {
      if (errorOccured)
        toast(({ closeToast }) => <WarningToast message={errMsg} />);
      return trackData;
    }).catch(err => {
      console.log("TrackDataLoadingError : ", err)
    })
  }

  const loadHarvestTracks =async(trackIds)=> {
    const xAccessToken = CookieManager.getCookie("x-access-token");
    const profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}"); 
    if(!profileData || !profileData?.email || profileData?.email?.length === 0){
        toast(({ closeToast }) => <ErrorToast message={"User profile loading error, Please login again."} />);
        return;
    }

    const trackData = {};
    const filter = {"ReturnCodes":"true", track : trackIds};
    await fetch(`${process.env.REACT_APP_BASE_URL}api/track/get-harvest-tracks`, 
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': xAccessToken,
                'x-auth': xAccessToken,
                'userId' : profileData?.email?.length > 0 ? Helper.encode(profileData.email) : "",
                'userType' : profileData?.userType?.length > 0 ? Helper.encode(profileData.userType) : ""
            },
            body: JSON.stringify({filter})
        }
    )
    .then(response => {
        // console.log("response : ", response);
        return response.json(); 
    })
    .then(resp => {
        // console.log('Data received:', resp);
        if(resp.data && resp?.success){

          resp.data.Tracks.forEach(elem => {
            if(!trackData[elem.ID])
              trackData[elem.ID] = {
                album: {title : elem.AlbumName, id : elem.AlbumID},
                duration: elem.LengthSeconds,
                bpm : elem.Bpm,
                mewoTrackId: elem.ID,
                trackId : elem.ID,
                //Don't have in this obj
                // mewoTrackUrl: elem.audiofile,
                // waveform: resp.waveform,
                title: elem.DisplayTitle,
                description : elem.Comment,
                artist : elem.Artist
              };
          })
        }else{
            console.error("track data loading error : ", resp)
            toast(({ closeToast }) => <ErrorToast message={"Track data loading error."} />);
        }
    })
    .catch(error => {
        console.error('Track data loading error:', error);
        toast(({ closeToast }) => <ErrorToast message={"Track data loading error"} />);
    })
    return trackData; 
  }
  const editProject = async (newindex) => {
    setCurrentProjectIndex(newindex);
    setTrackDataLoading(true);
    const { index, isOpen } = expanded;
    if (newindex >= 0) {
      let missingDetailsTrackIds = [];
      let newprojects = searchProjects;
      let project = { ...newprojects[newindex] };
      project.trackIds.forEach(async (item) => {
        item.alternateVersions = [];
        if ((item.trackId == undefined || item.trackId == null) 
          && !(missingDetailsTrackIds.indexOf(item.mewoTrackId) > -1) 
          && (newindex !== index || !isOpen))
            missingDetailsTrackIds.push(item.mewoTrackId);
      });
      if (missingDetailsTrackIds?.length > 0) {
        // const trackInfo = await getTracksInfo(missingDetailsTrackIds);
        const trackInfo = await loadHarvestTracks(missingDetailsTrackIds);
        // console.log("trackInfo Arr : ", trackInfo);
        const updatedTrackData = project.trackIds?.map(item => {
          if (trackInfo[item.mewoTrackId]) {
            item.trackId = trackInfo[item.mewoTrackId];
          }
          return item;
        });
        // console.log("updated track data : ", updatedTrackData)
        project.trackIds = updatedTrackData;
      }
      newprojects[newindex] = project;
      setSearchProjects(newprojects)
    }
    setEditProjectObj(searchProjects[newindex]);
    let newexpanded = { index: newindex, isOpen: newindex !== index ? true : !isOpen };
    setExpanded(newexpanded);
    setTrackData(newindex);
    setTrackDataLoading(false);
  }
  const deleteProject = (projectId, index) => {
    API.deleteProject(selectedAdmin.id).then(res => {
      // console.log('res delete project : ', res);
      if (res.success === false && res.code === '401') {
        trackContext.setShowSubscribePopup(true);
      } else {
        let newprojects = [...searchProjects];
        newprojects.splice(selectedAdmin.index, 1);
        setShowConfirmPopup(false)
        setSearchProjects(newprojects);
      }
    })

  }
  const updateProject = Helper.debounce((newTitle, index, title) => {
    let newProject = [...searchProjects];
    let obj = {};
    obj[title] = newTitle;
    newProject[index][title] = newTitle;
    setSearchProjects(newProject);
    API.updateProject(newProject[index]._id, { ...obj }).then(res => {

    });
  }, 500)
  const deleteTrackFromProject = async () => {
    let projectId = deletedTrackFromProject;
    let trackIndex = deletedTrackIndex;
    setShowTrackModal(false)
    setSavingProject(projectId);
    if (!trackContext.validateUser(Constants.ACTION.REMOVE_FROM_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.REMOVE_FROM_PROJECT);
      return;
    }
    let tempProject = searchProjects.filter(project => project._id === projectId);
    if (tempProject[0]?.trackIds?.length >= trackIndex) {
      tempProject[0].trackIds.splice(trackIndex, 1);
      //setting-up the "editProjectObj" for consolidated data save
      handleProjectDataChange(tempProject[0].trackIds, "tracks");
      await saveProject();
      setShowDeleteTrackConfirmPopup(false);
      setDeletedTrackFromProject("");
      setDeletedTrackIndex("");
      setDeletedTrackMsg("");
      let project = searchProjects.map((project) => {
        if (project._id === projectId) {
          return { ...project, trackIds: tempProject[0].trackIds };
        }
        return project;
      })
      setSearchProjects(project);
      setTrackData(currentProjectIndex);
      //resetting trackContext.alltrackData if track is deleted
      let index = searchProjects.findIndex(project => project._id === projectId);
      if (index === projectIndex && currentTrack !== '')
        trackContext.setalltrackData(setTrackData(index))
    }
    setSavingProject(null);
  }

  const deleteTrack = (projectId, projectName, trackName, trackIdx) => {
    setShowDeleteTrackConfirmPopup(true);
    setDeletedTrackIndex(trackIdx);
    setDeletedTrackFromProject(projectId);
    setDeletedTrackMsg(`Are you sure, you want to delete track : ${trackName}, from Project : ${projectName} ?`)
  }
  const setConfirmPopup = () => {
    setShowConfirmPopup(false)
  }

  const handleChange = async (project) => {
    if (!project?.trackIds?.length) {
      toast(({ closeToast }) => <ErrorToast message={"No tracks added in the project, add some tracks and try again."} />);
      return;
    }
    // let cachedUserData = JSON.parse(CookieManager.getCookie('user-data'));
    if (!trackContext.validateUser(Constants.ACTION.GENERATE_LICENSE)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.GENERATE_LICENSE);
      return;
    }
    window.location = "/license/" + project._id;

    // let userData = { id: cachedUserData._id };
    // if (cachedUserData?.userType === "ADMIN" || cachedUserData?.userType === "SUPER_ADMIN")
    //   userData = { id: cachedUserData.email, userType: "ADMIN" };
    // let resp = await API.validateSubscription(userData.id, userData.userType);
    // if (resp?.success) {
    //   if (resp.data?.userType === "FREE" || !resp.data?.subscribed) {
    //     trackContext.setShowSubscribePopup(true);
    //     trackContext.setUserAction(Constants.ACTION.GENERATE_LICENSE);
    //   } else {
    //     CookieManager.setCookie("user-data", JSON.stringify(resp.data));
    //     window.location = "/license/" + project._id;
    //   }
    // } else {
    //   let error = "Error while generating license : " + resp?.mssg;
    //   toast(({ closeToast }) => <ErrorToast message={error} />);
    // }

  }
  const generateLicense = (project) => {
    if (!project?.trackIds?.length) {
      toast(({ closeToast }) => <ErrorToast message={"No tracks added in the project, add some tracks and try again."} />);
      return;
    } else {
      if (!trackContext.validateUser(Constants.ACTION.GENERATE_LICENSE)) {
        trackContext.setShowSubscribePopup(true);
        trackContext.setUserAction(Constants.ACTION.GENERATE_LICENSE);
        return;
      }
      window.location = `/license/${project._id}`
    }
  }

  const handleSetAddProject = () => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }
    setAddProject({ title: true });

  }
  const handleRemoveAddProject = () => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }
    setAddProject({ title: false });

  }
  const handleProjectModal = (trackId, projectTrackId) => {
    setShowTrackModal(false)
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }
    setTrackToBeAddedToProject(trackId);
    setTrackToBeRemoveToProject(projectTrackId);
    setShowProjectModal(true);

  }

  // duplicate track
  const duplicateTrack = (value, parentIndex) => {
    setSearchProjects(
      searchProjects.map((prow, pindex) => {
        if (pindex === parentIndex) {

          return { ...prow, trackIds: [...prow.trackIds, value] };
        }
        return prow;
      })
    );
    //managing "editProjectObj" for consolidated data save
    let tracks = editProjectObj.trackIds;
    tracks.push(value);
    handleProjectDataChange(tracks);
  };

  // handle dragable events
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    let parentIndex = Number(result.source.droppableId.charAt(0));
    let searchProjects_ = searchProjects;
    const items = Array.from(searchProjects_[parentIndex].trackIds);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    searchProjects[parentIndex].trackIds = items;
    setSearchProjects(searchProjects);
    setTrackData(currentProjectIndex);
    handleProjectDataChange(items, "tracks");
  };

  const handleProjectDataChange = (value, valueType) => {
    let tempProject = editProjectObj;
    if (valueType === 'title')
      tempProject.title = value;
    else if (valueType === 'description')
      tempProject.description = value;
    else
      tempProject.trackIds = value;
    setEditProjectObj(tempProject);
  }

  const saveProject = async () => {
    setIsLoading(true);
    //moulding updated project data
    const tracks = editProjectObj?.trackIds?.map(elem => {
      if (!elem?.trackId?._id) {
        delete elem.trackId;
      }
      return elem;
    });
    editProjectObj.trackIds = tracks;
    await API.updateProject(editProjectObj._id, editProjectObj).then((res) => {
      if (res.success) {
        toast(({ closeToast }) => (
          <SuccessToast message={"Project : " + editProjectObj.title + " updated Successfully :)"} />
        ));
      } else {
        toast(({ closeToast }) => (
          <ErrorToast message={"Project : " + editProjectObj.title + " could not be updated! " + res.mssg} />
        ));
      }
    }).catch((err) => {
      console.log("Error Updating Project : ", err);
    });
    fetchProjects();
    setExpanded({ index: 0, isOpen: false });
    setEditProjectObj({});
  }

  const downloadPopupClose = () => {
    setDownloadProjectData(null)
    setShowDownloadModal(false);
  };

  const downloadProjectOld = (event, project) => {
    if (!project?.trackIds?.length) {
      toast(({ closeToast }) => <ErrorToast message={"No tracks added in the project, add some tracks and try again."} />);
      return;
    }
    if (downloadingProjects?.length > 0 || downloadProjectData) {
      toast(({ closeToast }) => <WarningToast message={`Project : "${downloadProjectData?.title}" is currently downloading. Try after completion.`} />);
      return;
    }

    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      setProjectDownloading(false);
      return;
    }

    setDownloadModalPosition(event.target)
    setShowDownloadModal(true);
    setDownloadProjectData({ projectId: project._id, ...project })
  };

  const handleProjectDownloadClose = () => {
    setProjectDownloadModal(false);
    setDownloadProjectData(null);
  }

  const handleProjectDownloadClick = (event, project) => {
    setProjectDownloadModalPosition(event.currentTarget)
    setProjectDownloadModal(true);
    setDownloadProjectData(project);
  }

  const downloadProject = async(format = "mp3") => {
    const projectId = downloadProjectData._id;
    if(!downloadProjectData || projectId?.length === 0)
      return;
    if (!downloadProjectData?.trackIds?.length) {
      toast(({ closeToast }) => <ErrorToast message={"No tracks added in the project, add some tracks and try again."} />);
      return;
    }
    if (downloadingProjects?.length > 0 && downloadingProjects.indexOf(downloadProjectData._id) > -1) {
      toast(({ closeToast }) => <WarningToast message={`Project : "${downloadProjectData?.title}" is currently downloading. Try after completion.`} />);
      return;
    }

    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }

    setDownloadingProjects([...downloadingProjects, projectId]);
    handleProjectDownloadClose();

    await API.downloadProject(projectId, format).then(resp => {
         if(resp.success)
          toast(({ closeToast }) => <SuccessToast message={"Download link shared on your email, please check your inbox."} />);
        else
          toast(({ closeToast }) => <ErrorToast message={"Project download Error : " + resp.mssg} />);
      }).catch(err =>{
        toast(({ closeToast }) => <ErrorToast message={"Project download Error : " + err.mssg} />);
      }).finally(() => {
        const tempData = downloadingProjects;
        tempData?.length > 0 && tempData.splice(tempData.indexOf(projectId), 1);
        setDownloadingProjects(tempData);
      })
  };

  const handleProjectDownloadOld = async (fileType, projectName) => {
    setShowDownloadModal(false);
    addDownloadingProjects(downloadProjectData?.projectId)
    let msg = "Your request is being processed, " + (fileType === 'original' ? "please wait." : "download will begin shortly.");
    toast(({ closeToast }) => <SuccessToast message={msg} />);

    await API.getProjectTracksZipped(downloadProjectData?.projectId, fileType)
      .then((res) => {
        //console.log('res zip download : ', res);
        if (res?.data?.success) {
          if (fileType != 'original') {
            window.open(res.data.downloadUrl, '_blank');
            if (res.data.message?.length > 0) {
              toast(({ closeToast }) => <WarningToast message={res.data.message} />);
              toast(({ closeToast }) => <SuccessToast message={`Downloading... ${downloadProjectData?.title ? 'Project : ' + downloadProjectData.title : 'Project'}`} />);
            } else
              toast(({ closeToast }) => <SuccessToast message={`Downloading... ${downloadProjectData?.title ? 'Project : ' + downloadProjectData.title : 'Project'}`} />);
          } else
            toast(({ closeToast }) => <SuccessToast message={res.data.message} />);
        } else {
          toast(({ closeToast }) => <ErrorToast message={"ProjectTracksZippingError : " + (res?.data?.mssg?.length ? res.data.mssg : res?.data?.message)} />);
        }
        removeDownloadingProjects(res.data.projectId);
      })
      .catch(err => {
        toast(({ closeToast }) => <ErrorToast message={"ProjectTracksZippingError : " + err?.message} />);
        removeDownloadingProjects(downloadProjectData?.projectId)
      });
    setDownloadProjectData(null)
  }

  const handleProjectDownload = async (fileType) => {
    setShowDownloadModal(false);
    addDownloadingProjects(downloadProjectData?.projectId)
    toast(({ closeToast }) => <SuccessToast message={"Your request is being processed, download will begin shortly."} />);

    const filesDataArr = [];
    const trackIds = [];
    let errMsg = "Info : No record found for Track(s) : ";
    let errorOccured = false;
    const taskArr = downloadProjectData.trackIds.map(async (track, index) => {
      //handling duplicate tracks download
      if (trackIds?.includes(track?.mewoTrackId))
        return;

      trackIds.push(track?.mewoTrackId);

      let reqObj = {
        url: `public/tracks/${track?.mewoTrackId}/files`,
        method: 'get'
      };

      await MewoService.loadMewoData(reqObj).then(async function (resp) {
        if (resp?.audiofile) {
          filesDataArr.push(resp.audiofile[fileType]);
        }
        return;
      }).catch(function (error) {
        console.log(`TrackDownloadError for Track : ${track?.trackId?.title}`, error);
        errorOccured = true;
        errMsg += `${track?.trackId?.title}, `
        return;
      });
    });

    await Promise.allSettled(taskArr).then(async results => {
      if (errorOccured)
        toast(({ closeToast }) => <WarningToast message={errMsg} />);

      await createLocalFile(filesDataArr);

    }).catch(err => {
      removeDownloadingProjects(downloadProjectData?.projectId);
      setDownloadProjectData(null);
      console.log("TrackDownloadError : ", err)
    })

  }

  const createLocalFile = async (filesDataArr) => {
    const zip = new JSZip();
    let count = 0;
    const zipFilename = `${downloadProjectData.title}.zip`;
    filesDataArr.forEach(async function (fileData) {
      if (fileData) {
        const filename = fileData.file_name;
        try {
          const file = await JSZipUtils.getBinaryContent(fileData.url)
          zip.file(filename, file, { binary: true });
          count++;
          if (count === filesDataArr.length) {
            await zip.generateAsync({ type: 'blob' }).then(function (content) {
              saveAs(content, zipFilename);
              removeDownloadingProjects(downloadProjectData?.projectId);
              setDownloadProjectData(null);
            });
          }
        } catch (err) {
          console.log('Track file downloading error : ', err);
        }
      }
    });
  }
  const addDownloadingProjects = (projectId) => {
    let temp = downloadingProjects;
    temp.push(projectId);
    setDownloadingProjects(temp);
  }

  const removeDownloadingProjects = (projectId) => {
    if (downloadingProjects?.length > 0 && projectId?.length > 0) {
      let temp = downloadingProjects;
      temp.pop(projectId);
      setDownloadingProjects(temp);
    }
  }

  const handleDownloadClick = async(event, trackId) => {
    setDownloadModalPosition(event.currentTarget);
    // setChilddownloadModalPosition(event.currentTarget);
    setShowDownloadModal(true);
    setDownloadingTrackId(trackId)
  }
  
  const downloadTrack = async (format="mp3") => {
    let cachedUserData = JSON.parse(CookieManager.getCookie("user-data"));
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
      if(!downloadingTrackId)
        return;
      setDownloadingTracks([...downloadingTracks, downloadingTrackId])
      const filter = {
        "Identifier": downloadingTrackId,
        "DownloadType": "track",
        "Format":format,
        "TrimStartSecs": 0,
        "TrimEndSecs": 0,
        "Email": cachedUserData.email,
        "IsShare": false,
        "Message": "",
        "SenderEmail": "",
        "ForceEmail": false,
        "IncludeVersions": false,
        "VersionFolderName": "",
        "DownloadFileName": "",
        "CuesheetFileName": "",
        "IncludeCuesheetFile": false
      }
      setDownloadingTrackId(null);
      await API.downloadTrack(filter).then(resp => {
        if(resp.success){
          toast(({ closeToast }) => <SuccessToast message={"Request processed. Download will begin shortly."} />);
          // console.log("track download resp : ", resp);
          if(resp.data?.DownloadTokens?.length > 0){
            const accessURLs = JSON.parse(localStorage.getItem("resourceURL")|| "{}");
            if(accessURLs?.DirectDownloadURL?.length > 0){
              const downloadURL = accessURLs.DirectDownloadURL.replace("{downloadtoken}", resp.data.DownloadTokens[0].TokenValue)
              const link = document.createElement('a');
              link.href = downloadURL;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        }
        else
          toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + resp.mssg || resp.err} />);
      }).catch(err =>{
        // console.log("Track download error : ", err);
        toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + err.mssg || err} />);
      }).finally(() => {
        const tempData = downloadingTracks;
        tempData?.length > 0 && tempData.splice(tempData.indexOf(downloadingTrackId), 1);
        setDownloadingTracks(tempData);
      })
    

  };
  return (
    <>
      {isLoading ?
        <div className='lg:w-full' style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"auto"}}>
          <BouncingLoader />
        </div> :
        <div className='md:m-10 lg:m-0 lg:w-full' style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"auto"}}>
          <div className='px-4 lg:pt-4 md:px-0'>
            <h1 className='text-xl lg:text-3xl font-bold mt-1 text-black' > Hello, {trackContext.userDetails.first_name}</h1>
            <h2 className='text-base lg:text-lg self-center text-textGray'> You have {totalProjects} Projects </h2>
          </div>
          <div className="flex w-full mt-2 lg:mt-6  md:px-0">
            <div className="w-full lg:pr-12">
              <div className="flex w-full">
                <span className='hidden lg:block lg:w-1/3 album-label' > My Projects</span>
                <div className="w-full lg:w-2/3 lg:justify-end flex">
                  {!addProject.title ?
                    <AddCircleIcon className="mr-2 cursor-pointer mt-1" onClick={handleSetAddProject} style={{ fontSize: "40px", color:"rgb(var(--pink))"}}/> :
                    <DisableAdd className="mr-2 mt-1 text-gray-400 cursor-pointer " onClick={handleRemoveAddProject} style={{ fontSize: "40px"}}/>
                  }
                  <input
                    onChange={(e) => { handleSearch(e.target.value) }}
                    // onChange={handleSearch}
                    type="text"
                    placeholder='Search Projects'
                    className="w-4/5 lg:w-2/5 search-icon h-8 rounded-2xl shadow-box"
                    style={{background :"rgb(var(--bg))"}}
                  />
                </div>
              </div>
              {addProject.title &&
                <>
                  <div className="w-full p-8 transform mt-4">
                    <div className="sm:flex w-full">
                      <div className="lg:w-3/4">
                        <input
                          autoFocus={true}
                          onChange={handleAddProject}
                          name="title"
                          className='lg:w-3/5 text-xl focus:outline-none font-semibold  border-b bg-transparent'
                          placeholder='Project Name...'
                        />
                        <div onClick={() => setAddProject({ title: true, description: !addProject.description })}
                          className="w-full cursor-pointer pt-2 text-lg">Add Description</div>
                      </div>

                      <div className=" hidden sm:block text-right  cursor-pointer  ml-2">
                        <div className={"rounded-3xl px-4 py-2 w-full text-center"}
                          onClick={(e) => createProject(e)}
                          disabled={!(project?.title?.length > 0)} 
                          style={{backgroundColor : project?.title?.length > 0 ? "black" : "gray", color : project?.title?.length > 0 ? "white" : "black"}}>
                          Create Project
                        </div>
                      </div>
                    </div>
                  </div>
                  {addProject.description &&
                    <div className=" w-full bg-black bg-textGray-200  transform mx-8">
                      <div className="w-full text-black text-lg">Description</div>
                      <textarea id="descripition" className="p-4 outline-none border border-textGray-300 text-textGray-100"
                        onChange={handleAddProject}
                        name="description" rows="1" cols="60" />
                    </div>
                    
                  }
                    <div className=" mt-4 cursor-pointer block sm:hidden ml-2">
                        <div className={"rounded-3xl px-4 py-2 w-full text-center"}
                          onClick={(e) => createProject(e)}
                          disabled={!(project?.title?.length > 0)} 
                          style={{backgroundColor : project?.title?.length > 0 ? "black" : "gray", color : project?.title?.length > 0 ? "white" : "black"}}>
                          Create Project
                        </div>
                      </div>
                </>

              }
              {projectDownloading ?
                <div className='lg:w-full'>
                  <BouncingLoader />
                </div> :
                <div className="w-full pt-4">
                  {
                    searchProjects.map((project, index) =>
                      <div key={project._id} className="w-full">
                        <div
                          className={`w-full border-b-2 border-symStrokeGrey pb-1 ${expanded.index === index && expanded.isOpen ? "hidden" : ""}`}>
                          <div className="w-full flex justify-between"  >
                            <div className="w-10/12 flex px-4 pt-4 pb-2"  onClick={() => { editProject(index); }}>
                              <p className='text-sm font-semibold text-black capitalize break-all' 
                              style={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 1,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                }}>{project.title} </p>
                            </div>
                            <div className="w-2/12 flex justify-end p-2 lg:hidden">
                              <div className="flex justify-center items-center">
                                <IconButton onClick={handleClick} style={{ padding: 4 }}>
                                  <MoreVertIcon style={{ fontSize: 20, color: "rgb(var(--text))" }} />
                                </IconButton>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose2}
                                  PaperProps={{
                                    elevation: 4,
                                    style: {
                                      borderRadius: 10,
                                      paddingTop: 4,
                                      paddingBottom: 4,
                                      marginLeft: "-20px", // custom shift for spacing
                                      background: "rgb(var(--canvas))",
                                      // bottom: "10px",
                                      right: "30px",
                                      width: "70px"
                                    },
                                  }}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                >
                                  <MenuItem
                                    onClick={() => { handleClose2();}}
                                    >
                                    
                                    <ListItemIcon>
                                      <EditIcon onClick={() => editProject(index)} 
                                        style={{ fontSize: "28px", color: "rgb(var(--text))" }} />
                                    </ListItemIcon>
                              
                                  </MenuItem> 
                                  
                                  <MenuItem 
                                    onClick={() => {
                                        setExpanded({ index: -1, isOpen: false });
                                        setSelectedAdmin({ id: project._id, index });
                                        setShowConfirmPopup(true);
                                        handleClose2();
                                      }}>
                                    <ListItemIcon>
                                      <DeleteIcon style={{ fontSize: "28px", color: "rgb(var(--text))" }} />
                                    </ListItemIcon>
                                  </MenuItem>
                              
                                  {project.trackIds?.length > 0 && 
                                  <MenuItem
                                      onClick={(event) => {
                                        handleClose2();
                                      }}
                                    >
                                    <ListItemIcon>
                                      {downloadingProjects.includes(project._id) ?
                                      <CircularProgress size='15px' /> :
                                      <SaveAltIcon
                                        style={{ fontSize: "28px", color: "rgb(var(--text))" }}
                                        onClick={(event) => handleProjectDownloadClick(event, project)}
                                        
                                      />}
                                    </ListItemIcon>
                                  </MenuItem>}

                                  <MenuItem
                                    onClick={() => {
                                      handleClose2();
                                    }}
                                  >
                                    <ListItemIcon>
                                      <ExpandMoreIcon
                                          onClick={() => editProject(index)}
                                          style={{ fontSize: "28px", color: "rgb(var(--text))"}} 
                                      />
                                    </ListItemIcon>
                                  </MenuItem>

                                </Menu>
                              </div>
                            </div>
                          </div>
                          <div className={`w-full flex justify-between `}>
                            <div className='w-1/2 flex'>
                              <div className={`cursor-pointer w-10 h-10 p-3 ml-4 mr-2 border self-center rounded-full linearGradient-${index % 15}`}
                                onClick={() => {
                                  editProject(index);
                                }}>
                                <Project />
                              </div>
                              <div  className='w-4/6 self-center cursor-pointer' onClick={() => {
                                editProject(index);
                              }}>
                                <div className=' text-xs  self-center text-textGray-100'>
                                  <p>
                                    {project.trackIds?.length} tracks
                                  </p>
                                  <p className='items-center text-xs text-textGray-100'>
                                    Edited on : {dayjs(project.updatedAt).format('DD.MM.YYYY')}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="w-1/2 flex self-center justify-end items-center hidden lg:flex">
                              {project.trackIds?.length > 0 && (
                                (project.licenseUrl === '' || typeof project.licenseUrl === 'undefined') ?
                                  <>
                                    <Link className="hidden lg:flex justify-end w-6/12">
                                      <button className={`mx-1 px-2  border-0`}
                                        onClick={() => handleChange(project)}
                                        style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                      >
                                        <PostAddIcon className='mr-1'/>
                                        Create Licence
                                      </button>
                                    </Link>
                                    <Link className="lg:hidden bl text-center ml-1  pinkbutton whitespace-nowrap w-4/12 ">
                                      <button className={`mx-1 px-2  border-0`}
                                          onClick={() => setShowMobilePopup(true)}
                                        style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                      >
                                        <PostAddIcon className='mr-1' />
                                        Create Licence
                                      </button>
                                    </Link>
                                  </>
                                  :
                                  (new Date(project.licenseUpdatedDate) < new Date(project.updatedAt)) ?
                                    <>
                                      <Link className="hidden lg:flex justify-end w-6/12">
                                        <button className={`mx-1 px-2  border-0`}
                                          onClick={() => generateLicense(project)}
                                          style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                        >
                                          <EditIcon className='mr-1' />
                                          Update Licence
                                        </button>
                                      </Link>
                                      <Link className="lg:hidden bl text-center ml-1  pinkbutton whitespace-nowrap w-4/12 ">
                                      <button className={`mx-1 px-2  border-0`}
                                          onClick={() => setShowMobilePopup(true)}
                                        style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                      >
                                        <EditIcon className='mr-1' />
                                        Update Licence
                                      </button>
                                    </Link>
                                    </> : <>
                                      <Link to={`/license/${project._id}`} className="hidden lg:flex justify-end w-6/12">
                                        <button className={`mx-1 px-2 border-0 `}
                                          style={{ fontSize: "12px", color: "white", background: "rgb(var(--green))"}}
                                        >
                                          <ArticleIcon className='mr-1'/>
                                          View Licence
                                        </button>
                                        </Link>
                                      <Link className="lg:hidden bl text-center ml-1  pinkbutton whitespace-nowrap w-4/12 ">
                                        <button className={`mx-1 px-2 border-0`}
                                          onClick={() => setShowMobilePopup(true)}
                                          style={{ fontSize: "12px", color: "white", background: "rgb(var(--green))"}}
                                        >
                                          <ArticleIcon className='mr-1'/>
                                          View Licence
                                        </button>
                                    </Link>
                                      </>
                              )}
                              
                              <div className='w-4/12 flex gap-x-4 justify-end items-center'>
                                <span className="hidden lg:block cursor-pointer ml-2" >
                                  <EditIcon style={{ fontSize: "24px"}} onClick={() => {
                                    editProject(index);
                                  }} />
                                </span>
                                
                                <span className="hidden lg:block cursor-pointer ml-2" >
                                  {project.trackIds?.length > 0 && (
                                    downloadingProjects.includes(project._id) ?
                                      <CircularProgress size='15px' /> :
                                      <SaveAltIcon
                                        style={{ fontSize: "24px"}}
                                        onClick={(event) => handleProjectDownloadClick(event, project)}
                                        
                                      />)
                                  }
                                </span>
                                <span className=" hidden lg:block cursor-pointer ml-2" >
                                  <DeleteIcon style={{ fontSize: "24px"}}
                                    onClick={() => {
                                      //deleteProject(project._id, index)
                                      setSelectedAdmin({ id: project._id, index });
                                      setShowConfirmPopup(true);
                                    }
                                    }
                                  />
                                </span>
                                <ExpandMoreIcon
                                  onClick={() => editProject(index)}
                                  style={{ fontSize: "35px" }}
                                  className="trackicon self-center cursor-pointer sm:text-gray-700"
                                />
                              </div>
                            </div>
                            {/* Mobile View - vertical buttons */}
                            <div className="lg:hidden flex flex-col gap-2 justify-start items-end mr-2 mt-1 w-1/2">
                              <div className="flex justify-center items-center">
                                  {project.trackIds?.length > 0 && (
                                  (project.licenseUrl === '' || typeof project.licenseUrl === 'undefined') ?
                                  <>
                                    <Link className="hidden lg:block w-10/12 lg:w-6/12">
                                      <button className={`mx-1 px-2  border-0`}
                                        onClick={() => handleChange(project)}
                                        style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                      >
                                        <PostAddIcon className='mr-1'/>
                                        Create Licence
                                      </button>
                                    </Link>
                                    <Link className="lg:hidden bl text-center ml-1  mt-2">
                                      <button className={`mx-1 px-2  border-0`}
                                          onClick={() => handleChange(project)}
                                        style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                      >
                                        <PostAddIcon className='mr-1' />
                                        Create Licence
                                      </button>
                                    </Link>
                                  </>
                                  :
                                  (new Date(project.licenseUpdatedDate) < new Date(project.updatedAt)) ?
                                    <>
                                      <Link className="hidden lg:block w-10/12 lg:w-6/12">
                                        <button className={`mx-1 px-2  border-0`}
                                          onClick={() => generateLicense(project)}
                                          style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                        >
                                          <EditIcon className='mr-1' />
                                          Update Licence
                                        </button>
                                      </Link>
                                      <Link className="lg:hidden bl text-center ml-1  mt-2 ">
                                      <button className={`mx-1 px-2  border-0`}
                                          onClick={() => generateLicense(project)}
                                        style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                      >
                                        <EditIcon className='mr-1' />
                                        Update Licence
                                      </button>
                                    </Link>
                                    </> : <>
                                      <Link to={`/license/${project._id}`} className="hidden lg:block  w-10/12 lg:w-6/12">
                                        <button className={`mx-1 px-2 border-0 `}
                                          style={{ fontSize: "12px", color: "white", background: "rgb(var(--green))"}}
                                        >
                                          <ArticleIcon className='mr-1'/>
                                          View Licence
                                        </button>
                                        </Link>
                                      <Link to={`/license/${project._id}`} className="lg:hidden bl text-center">
                                        <button className={`mx-1 px-2 border-0`}
                                          // onClick={() => setShowMobilePopup(true)}
                                          style={{ fontSize: "12px", color: "white", background: "rgb(var(--green))"}}
                                        >
                                          <ArticleIcon className='mr-1'/>
                                          View Licence
                                        </button>
                                    </Link>
                                      </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {savingProject === editProjectObj.id ?
                          <div className='lg:w-full'>
                            <BouncingLoader />
                          </div> :
                          (expanded.index === index && expanded.isOpen &&
                            <div className={`w-full transform flex flex-col`} >
                              <div className="w-full sm:w-full self-center" 
                                style={{background : "#ededed", color : "rgb(var(--header))"}}>
                                <div className="lg:flex w-full ">
                                  <div className="w-full flex">
                                    <div className="w-10/12  flex flex-wrap lg:w-8/12 p-4">
                                      <div className="w-full">
                                        <input
                                          autoFocus={true}
                                          onChange={(e) => { handleProjectDataChange(e.target.value, "title") }}
                                          className="text-xl focus:outline-none  border-b border-black font-semibold bg-transparent w-full"
                                          placeholder="edit Project..."
                                          defaultValue={project.title}
                                        />
                                        <div className="w-full pt-2 text-lg">
                                          {project.trackIds?.length} tracks
                                        </div>
                                        <h2 style={{ fontSize: "12px" }} className="w-full pt-2 text-left ">
                                          Edited on : {dayjs(project.updatedAt).format('DD.MM.YYYY')}
                                        </h2>
                                      </div>
                              

                                    </div>
                                    <div className="lg:hidden flex flex-col gap-2 justify-start items-end mr-2 mt-2 w-2/12">
                                      <div className="flex justify-center items-center">
                                        <IconButton onClick={handleClick1} style={{ padding: 4 }}>
                                          <MoreVertIcon style={{ fontSize: 20, color: "black" }} />
                                        </IconButton>
                                        <Menu
                                          anchorEl={anchorEl1}
                                          open={open1}
                                          onClose={handleClose1}
                                          PaperProps={{
                                            elevation: 4,
                                            style: {
                                              borderRadius: 10,
                                              paddingTop: 4,
                                              paddingBottom: 4,
                                              marginLeft: "-20px", // custom shift for spacing
                                              background: "rgb(var(--canvas))",
                                              // bottom: "10px",
                                              right: "30px",
                                              width: "70px"
                                            },
                                          }}
                                          anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "right",
                                          }}
                                          transformOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                          }}
                                        >
                                          
                                          <MenuItem 
                                           onClick={() => {
                                            setExpanded({ index: -1, isOpen: false });
                                            setSelectedAdmin({ id: project._id, index });
                                            setShowConfirmPopup(true);
                                            handleClose1();
                                          }}>
                                            <ListItemIcon>
                                              <DeleteIcon style={{ fontSize: "28px", color: "rgb(var(--text))" }} />
                                            </ListItemIcon>
                                          </MenuItem>
                                      
                                          {project.trackIds?.length > 0 && 
                                          <MenuItem
                                              onClick={(event) => {
                                                handleClose1();
                                              }}
                                            >
                                            <ListItemIcon>
                                              {downloadingProjects.includes(project._id) ?
                                              <CircularProgress size='15px' /> :
                                              <SaveAltIcon
                                                style={{ fontSize: "28px", color: "rgb(var(--text))" }}
                                                onClick={(event) => {handleProjectDownloadClick(event, project); handleClose1();}}
                                                
                                              />}
                                            </ListItemIcon>
                                          </MenuItem>}

                                          <MenuItem
                                            onClick={() => {
                                              handleClose1();
                                            }}
                                          >
                                            <ListItemIcon>
                                              <ExpandLessIcon
                                                  onClick={() => {setExpanded({ index: 0, isOpen: false }); setEditProjectObj({}); handleClose1();}}
                                                  style={{ fontSize: "28px", color: "rgb(var(--text))"}} 
                                              />
                                            </ListItemIcon>
                                          </MenuItem>

                                        </Menu>
                                      </div>
                                      
                                    </div>
                                  </div>
                                  <div className="w-6/12  flex  flex-wrap justify-end self-center hidden lg:flex" style={{marginTop : "-40px"}}>
                                    <div className=" flex justify-end  sm:self-end w-full   items-end self-center">

                                      {project.trackIds?.length === 0 ? (
                                        <div className='w-3/6'>
                                          <button className={`mx-1 px-2 border-0`}
                                            onClick={() => saveProject()}
                                            style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                              <SaveIcon className='mr-1' />
                                              Save
                                          </button>
                                        </div>
                                      ) : (
                                        // Jo existing code hai, wahi chalayega
                                        <div className='w-4/6 flex gap-x-2 justify-end'>
                                          {project.trackIds?.length > 0 ? (
                                            (project.licenseUrl === '' || typeof project.licenseUrl === 'undefined') ? (
                                              <div className=' flex flex-col  w-auto md:flex-row justify-around  md:items-center md:gap-2'>
                                                {/* Desktop */}
                                                <div className='hidden md:flex  w-full justify-around'>
                                                  {/* <div className={`pinkbutton lg:hidden`}
                                                    onClick={() => setShowMobilePopup(true)}
                                                    style={{ fontSize: "10px" }}
                                                  >Generate Licence</div> */}

                                                  <button className={`lg:hidden mx-1 px-2  border-0`}
                                                    onClick={() => setShowMobilePopup(true)}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                                  >
                                                    <PostAddIcon className='mr-1'/>
                                                    Create Licence
                                                  </button>

                                                  {/* <div className={`ml-1 lg:block hidden lg:ml-0 2xl:ml-1 pinkbutton`}
                                                    onClick={() => generateLicense(project)}
                                                    style={{ fontSize: "10px" }}
                                                  >Generate Licence</div> */}
                                                    
                                                  <button className={`lg:block hidden mx-1 px-2  border-0`}
                                                    onClick={() => generateLicense(project)}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                                  >
                                                    <PostAddIcon className='mr-1'/>
                                                    Create Licence
                                                  </button>
                                                  <button className={`mx-1 px-2 border-0`}
                                                    onClick={() => saveProject()}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                                      <SaveIcon className='mr-1' />
                                                      Save
                                                  </button>
                                                    
                                                </div>

                                                {/* Mobile - vertical buttons */}
                                                <div className='md:hidden flex flex-col gap-2'>
                                                  {/* <div className='pinkbutton' onClick={() => setShowMobilePopup(true)} style={{ fontSize: "10px" }}>
                                                    Generate Licence
                                                  </div> */}
                                                  <button className={`lg:block hidden mx-1 px-2  border-0`}
                                                    onClick={() => setShowMobilePopup(true)}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                                  >
                                                    <PostAddIcon className='mr-1'/>
                                                    Create Licence
                                                  </button>

                                                  <button className={`mx-1 px-2 border-0`}
                                                    onClick={() => saveProject()}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                                      <SaveIcon className='mr-1' />
                                                      Save
                                                  </button>
                                                </div>
                                              </div>
                                            ) : new Date(project.licenseUpdatedDate) < new Date(project.updatedAt) ? (
                                              <div className='w-auto flex flex-col md:flex-row justify-around  md:items-center md:gap-2'>
                                                {/* Desktop */}
                                                <div className='hidden md:flex  w-full justify-around'>
                                                  {/* <div className={`pinkbutton lg:hidden`}
                                                    onClick={() => setShowMobilePopup(true)}
                                                    style={{ fontSize: "10px" }}
                                                  >Update Licence</div> */}
                                                  <button className={`lg:hidden mx-1 px-2  border-0`}
                                                    onClick={() => setShowMobilePopup(true)}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                                  >
                                                    <EditIcon className='mr-1' />
                                                    Update Licence
                                                  </button>

                                                  <Link to={`/license/${project._id}`} className={`ml-1 lg:block hidden`} >
                                                    <button className={`mx-1 px-2  border-0`}
                                                      style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                                    >
                                                      <EditIcon className='mr-1' />
                                                      Update Licence
                                                    </button>
                                                  </Link>
                                                  <button className={`mx-1 px-2 border-0`}
                                                    onClick={() => saveProject()}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                                      <SaveIcon className='mr-1' />
                                                      Save
                                                  </button>
                                                </div>

                                                {/* Mobile - vertical buttons */}
                                                <div className='md:hidden flex flex-col gap-2'>
                                                  {/* <div className='pinkbutton' onClick={() => setShowMobilePopup(true)} style={{ fontSize: "10px" }}>
                                                    Update Licence
                                                  </div> */}
                                                  <button className={`mx-1 px-2  border-0`}
                                                    onClick={() => setShowMobilePopup(true)}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                                  >
                                                    <EditIcon className='mr-1' />
                                                    Update Licence
                                                  </button>
                                                  <button className={`mx-1 px-2 border-0`}
                                                    onClick={() => saveProject()}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                                      <SaveIcon className='mr-1' />
                                                      Save
                                                  </button>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className='w-auto flex flex-col md:flex-row justify-around  md:items-center md:gap-2'>
                                                {/* Desktop */}
                                                <div className='hidden md:flex w-full justify-around'>
                                                  {/* <div className={`greenbutton lg:hidden`}
                                                    onClick={() => setShowMobilePopup(true)}
                                                    style={{ fontSize: "10px" }}
                                                  >View Licence</div> */}
                                                  <button className={`lg:hidden mx-1 px-2 border-0`}
                                                    style={{ fontSize: "12px", background: "rgb(var(--green))", color: "white"}}
                                                    onClick={() => setShowMobilePopup(true)}
                                                  >
                                                    <ArticleIcon className='mr-1'/>
                                                    View Licence
                                                  </button>
                                                  <Link to={`/license/${project._id}`} className={`ml-1 lg:block hidden `} >
                                                    <button className={`mx-1 px-2 border-0`}
                                                      style={{ fontSize: "12px", background: "rgb(var(--green))", color: "white"}}
                                                    >
                                                      <ArticleIcon className='mr-1'/>
                                                      View Licence
                                                    </button>
                                                  </Link>
                                                  <button className={`mx-1 px-2 border-0`}
                                                    onClick={() => saveProject()}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                                      <SaveIcon className='mr-1' />
                                                      Save
                                                  </button>
                                                </div>

                                                {/* Mobile - vertical buttons */}
                                                <div className='md:hidden flex flex-col gap-2'>
                                                  {/* <div className='greenbutton' onClick={() => setShowMobilePopup(true)} style={{ fontSize: "10px" }}>
                                                    View Licence
                                                  </div> */}

                                                  <button className={`mx-1 px-2 border-0`}
                                                    style={{ fontSize: "12px", background: "rgb(var(--green))", color: "white"}}
                                                    onClick={() => setShowMobilePopup(true)}
                                                  >
                                                    <ArticleIcon className='mr-1'/>
                                                    View Licence
                                                  </button>
                                                  <button className={`mx-1 px-2 border-0`}
                                                    onClick={() => saveProject()}
                                                    style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                                      <SaveIcon className='mr-1' />
                                                      Save
                                                  </button>
                                                </div>
                                              </div>
                                            )
                                          ) : (
                                            <div className='w-full flex flex-col gap-2'></div>
                                          )}
                                        </div>
                                      )}

                                      <span className="hidden  lg:block flex gap-x-4 w-2/6 justify-end mx-2 mb-2" 
                                        style={{ display: "flex", alignItems: "center"}}>
                                        
                                        <span className="hidden lg:block cursor-pointer" >
                                          {project.trackIds?.length > 0 && (
                                            downloadingProjects.includes(project._id) ?
                                              <CircularProgress size='15px' /> :
                                              <SaveAltIcon
                                                style={{ fontSize: "24px", color: "rgb(var(--text))"}}
                                                onClick={(event) => handleProjectDownloadClick(event, project)}
                                              />)
                                          }
                                        </span>
                                        <DeleteIcon 
                                          style={{ fontSize: "24px", color: "rgb(var(--text))"}} 
                                          className="cursor-pointer text-[rgb-var((--text))]"
                                          onClick={() => {
                                            setExpanded({ index: -1, isOpen: false });
                                            setSelectedAdmin({ id: project._id, index });
                                            setShowConfirmPopup(true);
                                          }} 
                                        />

                                        <ExpandLessIcon
                                          onClick={() => editProject(index)}
                                          style={{ fontSize: "35px", color: "white" }}
                                          className="trackicon self-center cursor-pointer sm:text-gray-700"
                                        />
                                      </span>

                                      <div className="lg:hidden   w-full justify-end" >
                                        <span className='flex flex-row gap-x-4 justify-end ' style={{ "alignItems": "center" }}>
                                         <span className=" lg:hidden   cursor-pointer">
                                         <SaveIcon
                                            
                                            style={{ color: "white" }}
                                            onClick={() => {
                                              saveProject();
                                            }} />
                                         </span>
                                       

                                          <span className="lg:hidden   cursor-pointer">
                                            {
                                              downloadingProjects.includes(project._id) ?
                                                <CircularProgress size='15px' style={{ color: "white" }} /> :
                                                <DownloadIcon
                                                  size={20}
                                                  color={"rgb(var(--text))"}
                                                  onClick={(event) => handleProjectDownloadClick(event, project)}
                                                  // width="30"
                                                  // style={{ color: "white" }}
                                                />
                                            }
                                          </span>
                                          <span className=" lg:hidden    cursor-pointer">
                                            <Delete1  
                                                  
                                                  className='w-5 h-5'
                                                  style={{ color: "white"   }}
                                                  onClick={() => {
                                                    setExpanded({ index: -1, isOpen: false });
                                                    setSelectedAdmin({ id: project._id, index });
                                                    setShowConfirmPopup(true);
                                                  }
                                                  } />
                                            </span>
                                        <span className="trackicon self-center cursor-pointer sm:text-gray-700">
                                        <ExpandLessIcon
                                            onClick={() => editProject(index)}
                                            style={{ fontSize: "35px", color: "white" }}
                                            
                                          />
                                        </span>
                                        </span>
                                      </div>
                                    </div>
                                   
                                  </div>
                                  <div className="w-full  flex  flex-col justify-end self-center items-center flex lg:hidden" >
                                    <div className=" w-full flex flex-col justify-center  items-end self-end">

                                      {project.trackIds?.length > 0 && (
                                      
                                        (project.licenseUrl === '' || typeof project.licenseUrl === 'undefined') ?
                                        <>
                                          <Link className="w-full flex">
                                            <button className={`mx-4 border-0 justify-center self-center w-full`}
                                                onClick={() => handleChange(project)}
                                              style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                            >
                                              <PostAddIcon className='mr-1' />
                                              Create Licence
                                            </button>
                                          </Link>
                                        </>
                                        :
                                        (new Date(project.licenseUpdatedDate) < new Date(project.updatedAt)) ?
                                          <>
                                            <Link className="w-full flex">
                                              <button className={`mx-4 border-0 justify-center self-center w-full`}
                                                  onClick={() => generateLicense(project)}
                                                style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}
                                              >
                                                <EditIcon className='mr-1' />
                                                Update Licence
                                              </button>
                                            </Link>
                                          </> : <>
                                          <Link to={`/license/${project._id}`} className="w-full flex">
                                              <button className={`mx-4 border-0 justify-center self-center w-full`}
                                                // onClick={() => setShowMobilePopup(true)}
                                                style={{ fontSize: "12px", color: "white", background: "rgb(var(--green))"}}
                                              >
                                                <ArticleIcon className='mr-1'/>
                                                View Licence
                                              </button>
                                            </Link>
                                          </>
                                      )}

                                      <div className='w-full flex'>
                                        <button className={`mx-4 border-0 justify-center self-center w-full`}
                                          onClick={() => saveProject()}
                                          style={{ fontSize: "12px", background: "rgb(var(--pink))", color: "white"}}>
                                            <SaveIcon className='mr-1' />
                                            Save
                                        </button>
                                      </div>

                                    </div>
                                   
                                  </div>
                                </div>
                              </div>
                              <div className="w-full bg-black p-4 bg-textGray-200">
                                <div className="w-full text-black text-lg">Description</div>

                                <textarea id="description" className="p-4 w-full lg:w-9/12 outline-none border border-textGray-300 text-textGray-100 textArea-description"
                                  onChange={(e) => { handleProjectDataChange(e.target.value, "description") }}
                                  defaultValue={project.description}
                                  name="descripition" rows="1" cols="60" />
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                  <Droppable droppableId={index + "characters"}>
                                    {(provided) => (
                                      <ul
                                        className="characters "
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                      >
                                        {project.trackIds.map((track, childIdx) => {
                                          return (
                                            <Draggable
                                              key={childIdx + track._id}
                                              draggableId={index + childIdx + track._id}
                                              index={childIdx}
                                              id={childIdx}
                                            >
                                              {(provided) => (
                                                <li
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                >
                                                  <div className="main-track-content">
                                                    <div
                                                      key={track._id}
                                                      className="flex w-full justify-between sm:justify-start box-border"
                                                      style={{ alignItems: "center" }}
                                                    >
                                                      
                                                      <div className="self-center play-button sm:w-2/12 flex p-0.5">
                                                        {track.trackId?.album?.id && track.artworkRef ? (
                                                          <Link className="self-center p-0.5"  to={`/album/${track.trackId?.album?.id}`}>
                                                            <img
                                                              src={track.artworkRef || defaultImage}
                                                              alt="Album cover"
                                                              className="flex rounded-md shadow-md transition-transform transform hover:scale-105"
                                                              width="85px"
                                                              onError={(e) => trackContext.setDefaultImage(e)}
                                                            />
                                                          </Link>
                                                        ) : (
                                                          <img
                                                            src={defaultImage}
                                                            alt="Default album cover"
                                                            className="flex rounded-md shadow-md"
                                                            width="80px"
                                                          />
                                                        )}
                                                        
                                                        <div className="w-1/3 flex lg:w-1/4   justify-center items-center px-1">
                                                          <button
                                                            aria-label="Play or Pause"
                                                            className="m-1 rounded-full border border-gray-400 shadow-sm flex items-center justify-center"
                                                            onClick={() => {playTrack(track)}}
                                                            style={{background: "rgb(var(--pink))", color: "rgb(var(--text))"}}
                                                          >
                                                            {trackContext.playPause &&
                                                              track.mewoTrackId === trackContext.currentTrackDetail.id ? (
                                                              <PauseIcon 
                                                                style={{color: "rgb(var(--bg))", height:"38px", width:"38px"}}/>
                                                            ) : (
                                                              <PlayArrowIcon style={{color: "rgb(var(--bg))", height:"38px", width:"38px"}}/>
                                                            )}
                                                          </button>
                                                        </div>
                                                      </div>

                                                      {track.trackId ?
                                                        <>
                                                          <div className='w-2/3 sm:w-3/12'>
                                                             <div className="t-title font-semibold text-sm sm:text-base" 
                                                                style={{
                                                                  display: "-webkit-box",
                                                                  WebkitLineClamp: 1,
                                                                  WebkitBoxOrient: "vertical",
                                                                  overflow: "hidden",
                                                                }}>
                                                                  {" "}
                                                                  {track.trackId?.title?.toLowerCase()}
                                                              </div>
                                                            <div className="t-artist text-xs sm:text-sm" 
                                                              style={{
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 1,
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden",
                                                              }}>
                                                              {track.trackId?.album?.title?.toLowerCase()}{" "}
                                                            </div>
                                                          </div>
                                                          <div className="hidden w-1/3 sm:block md:w-1/5 lg:w-4/12">
                                                            <SvgInline url={track.trackId?.waveform?.small?.url} />
                                                          </div>
                                                          <div className="hidden sm:block text-center text-xs w-1/12 self-center text-textGray-100">
                                                            {track.trackId?.duration &&
                                                              new Date(
                                                                track.trackId?.duration * 1000
                                                              )
                                                                .toISOString()
                                                                .substr(14, 5)}
                                                          </div>
                                                        </> :
                                                        <div className="hidden md:block text-center text-xs w-9/12 self-center text-textGray-100">
                                                          <p style={{ color: "red" }}>We have encounterd dificulties processing this track, please remove and add it again.</p>
                                                        </div>
                                                      }
                                                      <div className="sm:flex hidden sm:block sm:w-3/12 justify-end gap-x-4">
                                                        {track.trackId && <>

                                                          <TrackAction
                                                            setShowProjectModal={
                                                              setShowProjectModal
                                                            }
                                                            setTrackToBeAddedToProject={
                                                              setTrackToBeAddedToProject
                                                            }
                                                            setTrackToBeRemoveToProject={
                                                              setTrackToBeRemoveToProject
                                                            }
                                                            trackId={
                                                              track.mewoTrackId
                                                            }
                                                            projectTrackId={
                                                              track.trackId?._id
                                                            }
                                                            handleAddTrackToFavorites={
                                                              handleAddTrackToFavorites
                                                            }
                                                            trackData={track.trackId}
                                                            favs={favs}
                                                            download={download}
                                                            setDownload={setDownload}
                                                            projectId={project._id}
                                                            downloadCount={track.downloadCount}
                                                            projectList={searchProjects}
                                                            setProjectList={setSearchProjects}
                                                            downloadingTracks = {downloadingTracks}
                                                            setDownloadingTracks = {setDownloadingTracks}
                                                            favingTracks = {favingTracks}
                                                            handleDownloadClick = {handleDownloadClick}
                                                          />
                                                          <span
                                                            style={{ fontSize: "4px" }}
                                                            className="self-center cursor-pointer text-gray-600 hover:scale-50 px-1"
                                                            onClick={() =>
                                                              duplicateTrack(
                                                                track,
                                                                index
                                                              )}
                                                          >
                                                            <DuplicateIcon />
                                                          </span>

                                                        </>}
                                                        <div
                                                          className={`hidden sm:block px-1 py-1 text-xs cursor-pointer text-ctaRed self-center pl-0`}
                                                          onClick={(e) =>
                                                            deleteTrack(
                                                              project._id,
                                                              project.title,
                                                              track.trackId?.title,
                                                              childIdx
                                                            )
                                                          }
                                                        >
                                                          <DeleteIcon style={{ fontSize: "24px", color: "rgb(var(--text))"}} />
                                                        </div>
                                                      </div>

                                                      <MobileAction
                                                        className={'cursor-pointer'}
                                                        mewoTrackId={
                                                          track.mewoTrackId
                                                        }
                                                        id={track.trackId?._id}
                                                        handleProjectModal={
                                                          handleProjectModal
                                                        }
                                                        favs={favs}
                                                        handleAddTrackToFavorites={
                                                          handleAddTrackToFavorites
                                                        }
                                                        deleteTrackFromProject={
                                                          deleteTrackFromProject
                                                        }
                                                        duplicateTrack={
                                                          duplicateTrack
                                                        }
                                                        projectId={project._id}
                                                        projectTitle={project.title}
                                                        trackData={track.trackId}
                                                        projectIndex={index}
                                                        trackIndex={childIdx}
                                                        trackObj={track}
                                                        removeTrack={deleteTrack}
                                                        handleDownloadClick = {handleDownloadClick}
                                                      />
                                                    </div>
                                                    {track.expand && (
                                                      <div className="alternative-versions-wrapper md:p-2 w-full">
                                                        <div
                                                          className="album-info w-5/6 mb-4"
                                                          style={{ marginLeft: "8.5%" }}
                                                        >
                                                          <div className="flex mb-4">
                                                            <div className="pr-8 pb-2">
                                                              <p className="text-title text-gray-600">
                                                                Album
                                                              </p>
                                                              <h3 className="track-artist">
                                                                {
                                                                  track
                                                                    .alternateVersions[0]
                                                                    ?.album?.title
                                                                }
                                                              </h3>
                                                            </div>
                                                            <div className="pr-8 pb-2">
                                                              <p className="text-title text-gray-600">
                                                                Artists
                                                              </p>
                                                              <h3 className="track-artist">
                                                                {
                                                                  track
                                                                    .alternateVersions[0]
                                                                    ?.artists_publishing_ownerships[0]
                                                                    ?.artist?.full_name
                                                                }
                                                                {", " +
                                                                  track
                                                                    .alternateVersions[0]
                                                                    ?.artists_publishing_ownerships[0]
                                                                    ?.rights_type?.key}
                                                              </h3>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                </li>
                                              )}
                                            </Draggable>
                                          );
                                        })}
                                      </ul>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                              </div>
                            </div>
                          )}
                      </div>
                      //    </AccordionDetails>
                      //  </Accordion> 
                    )}
                  <div className='mt-8'>
                    <Pagination count={totalPages} onChange={handlePagination} variant="outlined" shape="rounded" />
                  </div>
                </div>}
            </div>
            {/* {
              showProjectModal &&

              <AddTrackToProjectPopup
                trackToBeAddedToProject={trackToBeAddedToProject}
                closeProjectModal={closeProjectModal}
                loadProjects={loadProjects}
              />
            } */}

          </div >
          {
            showConfirmPopup ?
              <DeleteProjectPopup
                yesAction={deleteProject}
                cancelAction={setConfirmPopup}
                title="Delete Project?" msg="Are you sure, you want to delete this project? This action cannot be undone." />
              :
              null
          }
          {
            showDeleteTrackConfirmPopup &&
            <ConfirmationPopup
              yesAction={deleteTrackFromProject}
              cancelAction={() => { setShowDeleteTrackConfirmPopup(false); setDeletedTrackFromProject(""); setDeletedTrackIndex("") }}
              title="Delete Track From Project" msg={deletedTrackMsg} />

          }
          {
            showMobilePopup ?
              <MobilePopup
                setShowMobilePopup={setShowMobilePopup}
              />
              :
              null
          }

        </div >
      }
      <Menu
        id="customized-menu"
        anchorEl={projectDownloadModalPosition}
        open={Boolean(projectDownloadModal)}
        onClose={handleProjectDownloadClose}
        style={{ width: "320px", zIndex: "inherit" }}
      >
        <MenuItem
          onClick={() => { downloadProject("aiff"); }}
          className="card-action"
        >
          <span className="card-action-text">
            AIFF
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => { downloadProject("mp3"); }}
          className="card-action"
        >
          <span className="card-action-text">
            MP3
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => { downloadProject("wav"); }}
          className="card-action"
        >
          <span className="card-action-text">
            WAV
          </span>
        </MenuItem>
      </Menu>
      <Menu
        id="customized-menu"
        anchorEl={downloadModalPosition}
        open={Boolean(showDownloadModal)}
        onClose={handleClose}
        style={{ width: "320px" }}
      >
        <MenuItem
          onClick={() => { downloadTrack("aiff"); setShowDownloadModal(false) }}
          className="card-action"
        >
          <span className="card-action-text">
            AIFF
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => { downloadTrack("mp3"); setShowDownloadModal(false) }}
          className="card-action"
        >
          <span className="card-action-text">
            MP3
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => { downloadTrack("wav"); setShowDownloadModal(false) }}
          className="card-action"
        >
          <span className="card-action-text">
            WAV
          </span>
        </MenuItem>
      </Menu>
    </>
  )
}
